/**
 * Internal actions for the InputField component.
 */
export var InputFieldInternalAction;
(function (InputFieldInternalAction) {
    /**
     * Accept an email suggestion.
     */
    InputFieldInternalAction["AcceptEmailSuggestion"] = "AcceptEmailSuggestion";
})(InputFieldInternalAction || (InputFieldInternalAction = {}));
//# sourceMappingURL=internal-action.js.map